import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IconCreditCard } from "@tabler/icons-react";
import { MButton } from "@/components/ui/atoms/MButtons";
import MBadge from "@/components/ui/atoms/MBadge";
import { useTranslation } from "react-i18next";
import styles from "./SubscriptionSuccess.module.css";

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const planName =
    location.state?.planName || t("subscription.success.defaultPlanName");
  const renewalDate = location.state?.renewalDate || "";

  return (
    <div className={styles.container}>
      <div className="onboarding-ellipses">
        <div className="ellipse-onboarding-success ellipse-1"></div>
        <div className="ellipse-onboarding-success ellipse-2"></div>
        <div className="ellipse-onboarding-success ellipse-3"></div>
        <div className="ellipse-onboarding-success ellipse-4"></div>
        <div className="ellipse-onboarding-success ellipse-5"></div>
      </div>

      <div className={styles.content}>
        <h1 className={styles.title}>{t("subscription.success.title")}</h1>
        <p className={styles.description}>
          {t("subscription.success.description")}
        </p>

        <div className={styles.planCard}>
          <div className={styles.planHeader}>
            <IconCreditCard size={24} color="#7046AE" />
            <span className={styles.planName}>{planName}</span>
            <MBadge variant="green">
              {t("subscription.success.activeBadge")}
            </MBadge>
          </div>

          <p className={styles.renewalText}>
            {t("subscription.success.renewalText", { date: renewalDate })}
          </p>
        </div>
      </div>

      <div className={styles.footer}>
        <MButton
          variant="filled"
          size="lg"
          text={t("subscription.success.doneButton")}
          onClick={() => navigate("/dashboard")}
          className={styles.doneButton}
        />
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
